export default{
  illus: {
    logo: require('../../assets/img/illustrationx.svg'),
    logorev: require('../../assets/img/illustrationx-white.svg'),
    alt: {
      uk:'IllustrationX UK',
      us:'Illustration USA Inc',
      au:'IllustrationX Australia',
      fr:'IllustrationX France',
      br:'IllustrationX Brazil',
      sx:'IllustrationX South America',
      in:'IllustrationX India',
      sg:'IllustrationX SE Asia'
    }
  },
  anim: {
    logo: require('../../assets/img/animationx.svg'),
    logorev: require('../../assets/img/animationx-white.svg'),
    alt: {
      uk:'AnimationX UK',
      us:'AnimationX USA',
      au:'AnimationX Australia',
      fr:'AnimationX France',
      br:'AnimationX Brazil',
      sx:'AnimationX South America',
      in:'AnimationX India',
      sg:'AnimationX SE Asia'
    }
  }
}